
/**
 * 数据格式化，pipeline的数据都先经过这个插件处理
 */

import Smiley from '@ali/tarzan-smiley';
import util from '../../lib/util';

const RegLink = /\<link[^\>]+\>/igm;
const RegScript = /\<script.*\<\/script\>/g;
const SXM_SMILEY = {
  '[Chuckle]': 'https://gw.alicdn.com/tfs/TB1rG5qQVXXXXcLXXXXXXXXXXXX-34-34.png',
  '[Clap]': 'https://gw.alicdn.com/tfs/TB1RPuxQVXXXXX1XXXXXXXXXXXX-34-34.png',
  '[Drool]': 'https://gw.alicdn.com/tfs/TB1V8KsQVXXXXbJXXXXXXXXXXXX-34-34.png',
  '[NosePick]': 'https://gw.alicdn.com/tfs/TB11MB1QVXXXXcPXFXXXXXXXXXX-34-34.png',
  '[Shrunken]': 'https://gw.alicdn.com/tfs/TB1JwxMQVXXXXaNaXXXXXXXXXXX-34-34.png',
  '[Smug]': 'https://gw.alicdn.com/tfs/TB1r.t5QVXXXXX1XFXXXXXXXXXX-34-34.png',
  '[Wrath]': 'https://gw.alicdn.com/tfs/TB1ZDCoQVXXXXcOXXXXXXXXXXXX-34-34.png',
  '[Yawn]': 'https://gw.alicdn.com/tfs/TB166OsQVXXXXbBXXXXXXXXXXXX-34-34.png',
};

function sxmSmiley(text) {
  let message = text;
  // eslint-disable-next-line
  for (let k in SXM_SMILEY) {
    if (message.indexOf(k) >= 0) {
      message = message.replace(k, `<img src="${SXM_SMILEY[k]}" class="smiley" alt="" />`);
    }
  }
  return message;
}

export default function format(data) {
  const res = Object.assign({}, data);
  // 文本处理
  if (res && res.text && util.isString(res.text)) {
    let text = res.text;
    // 表情转换
    text = Smiley.toImage(text, 'large');
    // 样式标签过滤
    text = text.replace(RegLink, '');
    // script标签过滤
    text = text.replace(RegScript, '');

    text = sxmSmiley(text);

    res.text = text;
  }
  return res;
}



// WEBPACK FOOTER //
// ./src/app/extension/format.js